<template>
  <!--  工业-->
  <div class="waiceng">
    <el-menu
        :default-active="dictDataType"
        class="el-menu-vertical-demo"
        :unique-opened="true"
        @select="selectChange">
      <el-submenu index="工业增加值">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">工业增加值</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_industry_metal">工业增加值:黑色金属冶炼及压延加工业:当月同比</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_industry_car">工业增加值:汽车制造业:当月同比</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="营业收入">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">营业收入</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_income_metal">黑色金属冶炼及压延加工业:营业收入:累计值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_income_car">汽车制造:营业收入:累计值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="工业利润">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">工业利润</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_profit_metal">黑色金属冶炼及压延加工业:利润总额:累计值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_profit_car">汽车制造:利润总额:累计值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="采购经理人指数PMI">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">采购经理人指数PMI</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_purchase_pim">PMI</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_purchase_production">PMI:生产</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_purchase_order">PMI:新订单</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_purchase_yield">PMI:原材料库存</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_purchase_people">PMI:从业人员</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_purchase_time">PMI:供货商配送时间</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="工业产品产量">
        <template slot="title">
          <span><em class="redIcon"></em><i class="write">工业产品产量</i></span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_coal">产量:原煤:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_coke">产量:焦炭:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_electric">产量:发电量:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_fire">产量:火电:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_oil">产量:天然原油:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_natural">产量:天然气:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_ethylene">产量:乙烯:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_fibre">产量:化学纤维:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_iron">产量:铁矿石原矿量:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_foundry">产量:生铁:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_crude">产量:粗钢:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_steel">产量:钢材:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_aluminum">产量:铝材:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_cement">产量:水泥:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_tractor">产量:大中型拖拉机:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_ship">产量:民用钢制船舶:当月值</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="issue_macroscopic_yield_car">产量:汽车:当月值</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <Detail class="detail" :dictDataType="dictDataType"></Detail>
  </div>
</template>

<script>
import Detail from '@/components/macroscopic/detail'

export default {
  name: "economics",
  components: {
    Detail
  },
  data() {
    return {
      dictDataType: 'issue_macroscopic_industry_metal',
    }
  },
  created() {
  },
  methods: {
    /**
     * 切换详情
     * @param index
     */
    selectChange(index) {
      this.dictDataType = index;
    }
  },
}
</script>

<style scoped lang="less">
.detail {

}

.el-menu {
  color: #222222;
  display: inline-block;
  vertical-align: top;
  width: 236px;
  min-height: 688px;
  box-shadow: 0px 2px 10px 0px rgb(183 183 183 / 50%);
}

.redIcon {
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #D3131A;
  border-radius: 1px;
  font-style: normal;
  margin-right: 15px;
  vertical-align: middle;
}

.write {
  font-style: normal;
  vertical-align: middle;
  display: inline-block
}
</style>
